import Menu from '@/global/components/Menu'
import { IconButton } from '@mui/material'
import { EllipsisVerticalIcon } from 'lucide-react'

export function renderActions(actions: React.ReactNode) {
    if (!actions) return null
    if (Array.isArray(actions) && !actions.length) return null
    return (
        <Menu.Root arrow>
            <Menu.Trigger>
                <IconButton>
                    <EllipsisVerticalIcon />
                </IconButton>
            </Menu.Trigger>
            <Menu.List>{actions}</Menu.List>
        </Menu.Root>
    )
}
